<app-header></app-header>
<!-- ======= Hero Section ======= -->
<section id="hero" class="d-flex flex-column justify-content-end align-items-center">
    <div id="heroCarousel" class="container carousel carousel-fade" data-ride="carousel">

        <!-- Titulo -->
        <div class="carousel-item active">
            <div class="carousel-container" style="height: 100%;">
                <h2 class="mt-4 animate__animated animate__faster animate__fadeInDown" style="margin-bottom: 0px;">
                    {{ quiniela.titulo }}
                </h2>
                <div class="d-none d-sm-none d-md-block">
                    <!-- Botones en Escritorio -->
                    <div class="row">
                        <div class="col-sm">
                            <a routerLink="/quiniela/{{ quiniela.$key }}/jugadores" *ngIf="this.quiniela.activa" class="btn-get-started animate__animated animate__faster animate__fadeInDown" style="padding: .25rem .5rem;font-size: .875rem;line-height: 1.5;width: 150px;">
                                <i class="icofont-ui-user-group"></i> Participantes
                            </a>
                        </div>
                        <div class="col-sm">
                            <a routerLink="/compartir/{{ quiniela.$key }}" *ngIf="this.quiniela.activa" class="btn-get-started animate__animated animate__faster animate__fadeInDown" style="padding: .25rem .5rem;font-size: .875rem;line-height: 1.5;width: 150px;">
                                <i class="icofont-share"></i> Compartir
                            </a>
                        </div>
                        <div class="col-sm">
                            <a href="/tabla/{{ quiniela.$key }}" target="_blank" *ngIf="this.quiniela.activa" class="btn-get-started animate__animated animate__faster animate__fadeInDown" style="padding: .25rem .5rem;font-size: .875rem;line-height: 1.5;width: 150px;">
                                <i class="icofont-table"></i> Tabla
                            </a>
                        </div>
                    </div>
                </div>

                <marquee>
                    <p class="d-block d-sm-block d-md-none" style="font-size: 0.90rem;margin-bottom: 0px;">
                        <b>Selecciona el lapiz del partido correspondiente para ir colocando los resultados. Una vez colocado un resultado ya no entraran mas participantes</b>
                    </p>
                </marquee>
                <marquee>
                    <p class="d-none d-sm-none d-md-block" style="margin-bottom: 0px;">
                        <b>Selecciona el lapiz del partido correspondiente para ir colocando los resultados. Una vez colocado un resultado ya no entraran mas participantes</b>
                    </p>
                </marquee>


                <div class="d-block d-sm-block d-md-none">
                    <!-- Botones en Movil -->
                    <div class="row">
                        <div class="col-4">
                            <a routerLink="/quiniela/{{ quiniela.$key }}/jugadores" *ngIf="this.quiniela.activa" class="btn-get-started animate__animated animate__faster animate__fadeInDown" style="padding: .25rem .5rem;font-size: 1.5rem;line-height: 1.5;">
                                <i class="icofont-ui-user-group"></i>
                            </a>
                        </div>
                        <div class="col-4">
                            <a routerLink="/compartir/{{ quiniela.$key }}" *ngIf="this.quiniela.activa" class="btn-get-started animate__animated animate__faster animate__fadeInDown" style="padding: .25rem .5rem;font-size: 1.5rem;line-height: 1.5;">
                                <i class="icofont-share"></i>
                            </a>
                        </div>
                        <div class="col-4">
                            <a href="/tabla/{{ quiniela.$key }}" target="_blank" *ngIf="this.quiniela.activa" class="btn-get-started animate__animated animate__faster animate__fadeInDown" style="padding: .25rem .5rem;font-size: 1.5rem;line-height: 1.5;">
                                <i class="icofont-table"></i>
                            </a>
                        </div>
                    </div>
                </div>

                <section id="services" class="services" style="padding: 1rem;width: 100%;">
                    <div class="container">

                        <app-loader *ngIf="isLoading"></app-loader>

                        <div *ngIf="!isLoading">

                            <!--Tabla para la vista de Escritorio-->
                            <div class="table-responsive mt-2 d-none d-sm-none d-md-block" *ngIf="this.partidos.length != []">
                                <table class="table table-bordered table-sm animate__animated animate__faster animate__fadeInDown" id="tablePartidos">
                                    <thead>
                                        <tr>
                                            <th class="text-white d-none d-sm-none d-md-block" scope="col">FECHA</th>
                                            <th scope="col" colspan="3" class="text-center text-white">EQUIPOS</th>
                                            <th class="text-white" scope="col"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let partido of partidos">
                                            <td class="text-white d-none d-sm-none d-md-block" scope="row">
                                                {{partido.fecha.split("-")[2]}}-{{partido.fecha.split("-")[1]}}
                                            </td>
                                            <td class="text-white">{{ partido.contrincante1 }}</td>
                                            <td class="text-white">{{ partido.resultado1 }} &nbsp;-&nbsp; {{ partido.resultado2 }}</td>
                                            <td class="text-white">{{ partido.contrincante2 }}</td>
                                            <td class="text-white">
                                                <a href="" data-toggle="modal" [attr.data-target]="'#' + partido.$key" *ngIf="this.quiniela.activa"><i class="icofont-ui-edit"
                                                        style="color: #ef6603"></i></a>
                                                <a (click)="BorrarPartido(partido.$key)" *ngIf="!this.quiniela.activa"><i class="icofont-ui-delete"
                                                        style="color: #dc3545"></i></a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <!--Tabla para la vista de Movil-->
                            <div class="table-responsive mt-2 d-block d-sm-block d-md-none" *ngIf="this.partidos.length != []">
                                <table class="table table-bordered table-sm animate__animated animate__faster animate__fadeInDown" id="tablePartidos">
                                    <thead>
                                        <tr>
                                            <th class="text-white d-none d-sm-none d-md-block" scope="col">FECHA</th>
                                            <th scope="col" colspan="3" class="text-center text-white">EQUIPOS</th>
                                            <th class="text-white" scope="col">ED.</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let partido of partidos">
                                            <td class="text-white d-none d-sm-none d-md-block" scope="row">
                                                {{partido.fecha.split("-")[2]}}-{{partido.fecha.split("-")[1]}}
                                            </td>
                                            <td class="text-white">{{ partido.contrincante1.substr(0,7) }}</td>
                                            <td class="text-white">{{ partido.resultado1 }} &nbsp;-&nbsp; {{ partido.resultado2 }}</td>
                                            <td class="text-white">{{ partido.contrincante2.substr(0,7) }}</td>
                                            <td class="text-white">
                                                <a href="" data-toggle="modal" [attr.data-target]="'#' + partido.$key" *ngIf="this.quiniela.activa"><i class="icofont-ui-edit"
                                                        style="color: #ef6603"></i></a>
                                                <a (click)="BorrarPartido(partido.$key)" *ngIf="!this.quiniela.activa"><i class="icofont-ui-delete"
                                                        style="color: #dc3545"></i></a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div *ngIf="!this.quiniela.activa">
                                <h5 class="mt-4 mb-2 text-white animate__animated animate__faster animate__fadeInDown" style="margin-bottom: 0px;">
                                    Agregar un nuevo Partido
                                </h5>
                                <div class="row">
                                    <div class="col-sm mb-2">
                                        <input type="date" data-date-format="DD MMMM" class="form-control" id="Fecha" placeholder="Ingrese la Fecha" style="height: 30px;" (keyup.enter)="AgregarPartido()">
                                    </div>
                                    <div class="col-sm mb-2">
                                        <input type="text" autocomplete="off" class="form-control input-sm" id="Equipo1" placeholder="Ingrese el equipo 1" style="height: 30px;" (keyup.enter)="AgregarPartido()">
                                    </div>
                                    <div class="col-sm mb-2">
                                        <input type="text" autocomplete="off" class="form-control input-sm" id="Equipo2" placeholder="Ingrese el equipo 2" style="height: 30px;" (keyup.enter)="AgregarPartido()">
                                    </div>
                                </div>
                                <a (click)="AgregarPartido()" class="btn-get-started animate__animated animate__faster animate__fadeInDown" style="padding: .25rem .5rem;font-size: .875rem;line-height: 1.5;">
                                    <i class="icofont-ui-add"></i> Agregar partido</a>

                                <a (click)="cerrar()" class="btn-get-started mt-5 animate__animated animate__faster animate__fadeInDown" style="width: 100%;padding: .5rem 1rem;
                                font-size: 1.25rem;line-height: 1.5;">
                                    Cerrar creación de la Quiniela</a>
                            </div>
                        </div>
                    </div>
                </section>
                <!-- End Services Section -->



            </div>
        </div>
    </div>


    <!-- Modal para Cerrar y avisar al usuario lo que implica -->
    <div *ngFor="let partido of partidos" class="modal fade" id="{{partido.$key}}" tabindex="-1" role="dialog" aria-labelledby="crearLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="crearLabel">Editar resultado</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <form>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-6">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text form-control-sm input-group-sm" style="width: 90px;">{{partido.contrincante1.substr(0,9)}}</span>
                                    </div>
                                    <input type="number" value="{{partido.resultado1}}" id="Resultado1-{{partido.$key}}" class="form-control form-control-sm input-group-sm" style="text-align: center;">
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="input-group mb-2">
                                    <input type="number" value="{{partido.resultado2}}" id="Resultado2-{{partido.$key}}" class="form-control form-control-sm input-group-sm" required style="text-align: center;">
                                    <div class="input-group-append">
                                        <span class="input-group-text form-control-sm input-group-sm" style="width: 90px;">{{partido.contrincante2.substr(0,9)}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" id="CloseButtonPartido-{{partido.$key}}" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                        <button type="button" (click)="editarResultado(partido)" class="btn btn-primary" style="background: #ef6603;color: #fff;border-color: #ef6603;">Aceptar</button>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <svg class="hero-waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 24 150 28 " preserveAspectRatio="none">
        <defs>
            <path id="wave-path" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
        </defs>
        <g class="wave1">
            <use xlink:href="#wave-path" x="50" y="3" fill="rgba(255,255,255, .1)" />
        </g>
        <g class="wave2">
            <use xlink:href="#wave-path" x="50" y="0" fill="rgba(255,255,255, .2)" />
        </g>
        <g class="wave3">
            <use xlink:href="#wave-path" x="50" y="9" fill="#fff" />
        </g>
    </svg>


</section>
<!-- End Hero -->